/* global fetch, Request, location */
import { register, find, applyAll } from '../../../../Javascript/Sysmex/Utils'

const ContentPopupTrigger = el => {
  const action = el.dataset.popupaction
  const target = el.dataset.popuptarget
  const contentUrl = el.dataset.popupcontenturl
  const isForm = el.dataset.isform
  const reloadOnClose = el.dataset.reloadonclose

  el.addEventListener('click', (event) => {
    if (isForm) {
      event.preventDefault()
    }

    // Find popup that should be triggered
    const targetElement = (target)
      ? find('[data-popupidentifier="' + target + '"]')
      : el.closest('[data-component="ContentPopup"]')

    const form = (isForm) ? el.closest('form') : null
    const method = (isForm) ? form.method : 'GET'
    const formData = (isForm) ? new URLSearchParams(new FormData(form)) : null

    const targetContentUrl = (isForm)
      ? contentUrl || form.action || targetElement.dataset.popupcontenturl
      : contentUrl || targetElement.dataset.popupcontenturl

    // Define new popup status
    let isOpened
    switch (action) {
      case 'open':
        isOpened = true
        break
      case 'close':
        isOpened = false
        break
      case 'toggle':
        isOpened = (targetElement.dataset.popupopened !== '1')
        break
    }

    // Load new popup content
    if (isOpened && targetContentUrl) {
      const contentElement = find('[data-popupcontentelement]', targetElement)

      // Clear popup content if popup isn't already open
      if (targetElement.dataset.popupopened !== '1') {
        contentElement.innerHTML = ''
      }

      targetElement.setAttribute('data-hasloadingspinner', 1)

      fetch(new Request(targetContentUrl, {
        method: method,
        body: formData,
        cache: 'no-cache',
        credentials: 'same-origin'
      })).then(response => {
        response.text().then(text => {
          contentElement.innerHTML = text
          targetElement.setAttribute('data-hasloadingspinner', 0)
          contentElement.setAttribute('data-fadeincontent', 1)
          applyAll(contentElement)
        })
      })
    }

    // Apply new popup status
    targetElement.setAttribute('data-popupopened', (isOpened) ? 1 : 0)

    // Save reloadOnClose status when popup opens
    if (isOpened) {
      targetElement.dataset.reloadonclose = (reloadOnClose) ? 1 : 0
    }

    // Reload page if popup closes and reload is requested
    if (!isOpened && targetElement.dataset.reloadonclose === '1') {
      location.reload()
    }
  })
}

register('ContentPopupTrigger', ContentPopupTrigger)
